<template>
  <div
    :class="$style.root"
  >
    <div :class="$style.label">
      {{ [$t('map.related.label'), label]?.filter(Boolean).join(': ') }}
    </div>

    <div
      :class="$style.container"
    >
      <SharedMapComponent
        :mapData="mapData"
        :projectAreasData="projectAreasData"
        :centerLatLong="centerLatLong"
        viewOption="embedded"
        :slug="slug"
      />
    </div>
</div>
</template>

<script setup>
const props = defineProps({
  centerLatLong: {
    type: Object,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
  slug: {
    type: String,
    required: false,
  }
})

// 1
// FIXME i18nIso
const i18nIso = 'nl-NL' //baseI18nGetDefaultIso()

const { data: mapData } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest', { query: { path: queryMapPage({locale: i18nIso}) } }
  )
})
mapData.value = baseStrapiGetAttributes(mapData.value)

const { data: projectAreasData } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest', { query: { path: queryProjectAreasMap({locale: i18nIso}) } }
  )
})
projectAreasData.value = projectAreasData?.value?.data
</script>

<style module>
.root {
  composes: font-size-default from global;

  margin-top: calc(var(--unit--vertical) * 2);

  display: flex;
  flex-direction: column;
  gap: calc(var(--lh, 1em) * 1);
}

.label {
  text-transform: uppercase;
}

.container {
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;

  position: relative;
}

.container :global(.mapboxgl-ctrl) {
  display: none !important;
}

.container :global(.mapboxgl-popup-tip) {
  visibility: hidden;
}
</style>
